import React from 'react';

const Abril2025_admin = () => {
  // Función genérica para hacer scroll sin tocar el URL
  const scrollToId = (id) => {
    const el = document.getElementById(id);
    if (!el) return;
    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <>
      <div className="scroll-smooth11">


        <h1 className="text-4xl font-bold mb-4">Novedades en Admin</h1>
        <p className="text-base text-gray-600 mb-1">Feature Updates</p>
        <p className="text-base text-gray-500 mb-6">
            Fecha de lanzamiento: <span className="font-semibold text-gray-700">Abril 2025</span>
        </p>

         {/* Índice de contenidos */}
         <ul className="list-disc list-inside mb-8 marker:text-black text-red-600 space-y-2">
          <li onClick={() => scrollToId('importador-masivo-imagenes')} className="cursor-pointer hover:text-red-800">
            Importador Masivo de Imágenes
          </li>
          <li onClick={() => scrollToId('orden-de-modificadores')} className="cursor-pointer hover:text-red-800">
            Orden de modificadores
          </li>
          <li onClick={() => scrollToId('advertencia-al-cambiar-de-sucursal')} className="cursor-pointer hover:text-red-800">
            Advertencia al cambiar de sucursal
          </li>
          <li onClick={() => scrollToId('pantalla-productos-retail')} className="cursor-pointer hover:text-red-800">
            Pantalla de Productos en negocios Retail
          </li>
        </ul>

        <span class="inline-flex items-center rounded-md bg-blue-50 px-4 py-1 text-md font-medium text-blue-700 ring-1 ring-blue-700/10 ring-inset mb-5">Nueva Función</span>
        <h2 id="importador-masivo-imagenes" className="text-3xl font-semibold mb-4">1. Importador Masivo de Imágenes</h2>
        <div className="mb-12">
          <p className="mb-4 text-gray-700 leading-relaxed text-lg">
            Subir imágenes una por una es cosa del pasado. Ahora puedes hacerlo todo de una sola vez con nuestro nuevo Importador Masivo de Imágenes.
          </p>
          <figure className="bg-white overflow-hidden mb-8">
            <img
              src="https://img.invupos.com/webinvu/Software%20release/Products/Admin/1.png"
              alt="Importador Masivo de Imágenes"
              className="w-full object-cover"
            />
          </figure>
          <h3 className="text-xl font-bold mb-4 mt-6">¿Cómo funciona?</h3>
          <ol className="list-decimal list-inside mb-6 text-lg">
            <li>Descarga la plantilla Excel desde el botón de "Importar Imágenes Masivamente" en la pestaña de Configuración.</li>
            <li>
              Llena el Excel con el código y nombre exacto de cada archivo de imagen
              (ítem, categoría, subcategoría o producto) incluyendo su extensión (.jpg, .jpeg, .png),
              y selecciona la opción correspondiente.
            </li>
            {/* <img
              src="https://img.invupos.com/webinvu/Software%20release/Versiones/Abril/Screen%20Shot%202025-05-08%20at%2010.38.47%20AM.png"
              alt="Importador Masivo de Imágenes"
              className="w-96 object-cover mt-4 mb-4"
            /> */}
            <li>Sube el archivo Excel usando "Subir archivo" y haz clic en Importar archivo.</li>
            <li>Arrastra y suelta todas las imágenes en la "Zona de Arrastre" para guardarlas en el sistema.</li>
          </ol>
        </div>

        <span class="inline-flex items-center rounded-md bg-green-50 px-4 py-1 text-md font-medium text-green-700 ring-1 ring-green-600/20 ring-inset mb-5">Mejora/Implementación</span>
        <h2 id="orden-de-modificadores" className="text-3xl font-semibold mb-4">2. Orden de modificadores</h2>
        <div className="mb-12">
          <ul className="list-disc list-inside mb-6 text-lg">
            <li>El campo antes llamado "Pedido por Ítems" fue renombrado a "Orden de Modificador" para mayor claridad.</li>
            <li>Al editar este campo desde una central, el cambio se replica automáticamente en todas las sucursales asociadas.</li>
          </ul>
        </div>

        <span class="inline-flex items-center rounded-md bg-purple-50 px-4 py-1 text-md font-medium text-purple-700 ring-1 ring-purple-700/10 ring-inset mb-5">Mejora de Experiencia de Usuario UX</span>
        <h2 id="advertencia-al-cambiar-de-sucursal" className="text-3xl font-semibold mb-4">3. Advertencia al cambiar de sucursal</h2>
        <div className="mb-12">
          <p className="mb-4 text-gray-700 leading-relaxed text-lg">
            Antes, si abrías distintas sucursales en varias pestañas, los cambios en una podían afectar la configuración de otra.
            Este comportamiento ya fue corregido.
          </p>
          <p className="mb-4 text-gray-700 leading-relaxed text-lg">
            Ahora, al abrir una sucursal en una nueva pestaña, verás:
          </p>
          <blockquote className="mb-6 px-4 py-2 bg-gray-100 border-l-4 border-gray-300 text-gray-700 italic">
            "La sucursal ha sido cambiada a [nombre de la sucursal] en otra pestaña. Por favor, recarga la página para sincronizar la sesión."
          </blockquote>
          <p className="text-gray-700 leading-relaxed text-lg mb-3">
            Esto evita errores de sincronización y protege la integridad de la configuración en entornos con múltiples sucursales.
          </p>
          <img
            src="https://img.invupos.com/webinvu/Software%20release/Products/Admin/3.png"
            alt="Advertencia al cambiar de sucursal"
            className="w-1/2 object-cover rounded-2xl border border-3"
          />
        </div>

        <span class="inline-flex items-center rounded-md bg-green-50 px-4 py-1 text-md font-medium text-green-700 ring-1 ring-green-600/20 ring-inset mb-5">Mejora/Implementación</span>
        <h2 id="pantalla-productos-retail" className="text-3xl font-semibold mb-4">4. Pantalla de Productos en negocios Retail</h2>
        <div className="mb-12">
          <p className="mb-4 text-gray-700 leading-relaxed text-lg">
            Ahora, en negocios configurados como tipo Retail, la sección Items Search muestra:
          </p>
          <ul className="list-disc list-inside mb-6 text-lg">
            <li>Información del producto: Categoría, Grupo, Familia, Costo</li>
            <li>Información específica del ítem: Subcategoría, Categoría, Precio de Venta, Impuesto</li>
          </ul>
          <p className="text-gray-700 leading-relaxed text-lg">
            Esto permite un control más detallado sobre la estructura y composición del catálogo de productos.
          </p>
        </div>

      </div>
    </>
  );
};

export default Abril2025_admin;
